"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageBookingNew = void 0;
const isValid_1 = __importDefault(require("date-fns/isValid"));
const roundToNearestMinutes_1 = __importDefault(require("date-fns/roundToNearestMinutes"));
const setHours_1 = __importDefault(require("date-fns/setHours"));
const setMinutes_1 = __importDefault(require("date-fns/setMinutes"));
const query_string_1 = require("query-string");
const react_1 = __importDefault(require("react"));
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const Booking_1 = require("../../models/Booking");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const BookingEditor_1 = require("../booking-editor/BookingEditor");
/**
 * Opens the booking editor to create a new booking.
 */
const ManagerPageBookingNew = (props) => {
    const config = (0, configContext_1.useConfig)();
    const location = (0, react_router_dom_1.useLocation)();
    const searchQuery = (0, query_string_1.parse)(location.search);
    const resourceId = searchQuery["resourceId"];
    const resource = typeof resourceId === "string"
        ? config.getResourceById(resourceId)
        : undefined;
    if (resource === undefined) {
        return (react_1.default.createElement(Container_1.default, { fluid: true },
            react_1.default.createElement(Alert_1.default, { className: "mt-3", variant: "danger" },
                "Keine ensprechende Ressource gefunden: resourceId=",
                resourceId)));
    }
    else {
        // Create a new booking.
        const newBooking = new Booking_1.Booking(resource.id, config);
        // Try to set a reasonable start date.
        const dateStr = searchQuery["date"];
        // If no valid date was provided, today is used.
        let start = new Date();
        if (typeof dateStr === "string") {
            const parsedDate = dateUtils.parseDateIso(dateStr);
            if ((0, isValid_1.default)(parsedDate)) {
                start = parsedDate;
            }
        }
        // Keep between reasonable working hours.
        let now = new Date();
        if (now.getHours() >= 17) {
            start = (0, setHours_1.default)(start, 15);
            start = (0, setMinutes_1.default)(start, 0);
        }
        else if (now.getHours() < 8) {
            start = (0, setHours_1.default)(start, 8);
            start = (0, setMinutes_1.default)(start, 0);
        }
        else {
            start = (0, setHours_1.default)(start, now.getHours());
            start = (0, setMinutes_1.default)(start, now.getMinutes());
            start = (0, roundToNearestMinutes_1.default)(start, { nearestTo: 30 });
        }
        // Default duration to 2 hours.
        const end = (0, setHours_1.default)(start, start.getHours() + 2);
        newBooking.start = start;
        newBooking.end = end;
        return react_1.default.createElement(BookingEditor_1.BookingEditor, { booking: newBooking });
    }
};
exports.ManagerPageBookingNew = ManagerPageBookingNew;
